var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaveCost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 27,
    viewBox: "0 0 33 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3217 10.4873C17.6514 11.9239 14.0412 11.5721 11.8383 10.986C11.138 10.7997 10.3809 11.3054 10.3809 12.0301V24.3796C10.3809 24.7343 10.5658 25.0665 10.891 25.2079C12.5085 25.9115 15.947 26.58 20.106 24.9521C23.8063 23.5038 27.5472 23.8733 29.8274 24.4679C30.5288 24.6508 31.2757 24.1337 31.2631 23.409L31.0556 11.4971C31.0501 11.1811 30.8978 10.882 30.6228 10.7262C29.0435 9.83135 25.556 8.82996 21.3217 10.4873Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2299 2.30537C8.55958 3.74194 4.94941 3.39012 2.74655 2.80406C2.04622 2.61774 1.28906 3.12348 1.28906 3.84818V16.1977C1.28906 16.5524 1.47396 16.8845 1.79919 17.026C3.41674 17.7296 6.85523 18.3981 11.0142 16.7702C14.7145 15.3219 18.4555 15.6913 20.7356 16.2859C21.437 16.4688 22.1839 15.9518 22.1713 15.227L21.9638 3.31511C21.9583 2.99912 21.806 2.70006 21.531 2.54426C19.9518 1.6494 16.4642 0.648012 12.2299 2.30537Z",
    stroke: "#03F5AE",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveCost);
export default __webpack_public_path__ + "static/media/saveCost.cd64946b4a84ea57f185eed09df413ab.svg";
export { ForwardRef as ReactComponent };